import { createAction, props } from '@ngrx/store';
import { ServiceTaskTab } from 'src/app/types/service-task.types';

export enum ServiceTaskActionTypes {
	InboxSortToggled = '[Component] Inbox Sort Toggled',
	ScheduledSortToggled = '[Component] Scheduled Sort Toggled',
	ServiceTaskTabChanged = '[Component] Service Task Tab Changed',
	InboxDateFilterChanged = '[Component] Inbox Date Filter Changed',
	ScheduledDateFilterChanged = '[Component] Scheduled Date Filter Changed',
	RemoveServiceTaskRequested = '[Component] Remove Service Task Requested',
	RemoveServiceTaskCompleted = '[Effect] Remove Service Task Completed'
}

export const inboxSortToggled = createAction(
	ServiceTaskActionTypes.InboxSortToggled
)

export const scheduledSortToggled = createAction(
	ServiceTaskActionTypes.ScheduledSortToggled
)

export const serviceTaskTabChanged = createAction(
	ServiceTaskActionTypes.ServiceTaskTabChanged,
	props<{ selectedTab: ServiceTaskTab }>()
)

export const inboxDateFilterChanged = createAction(
	ServiceTaskActionTypes.InboxDateFilterChanged,
	props<{ dateFilter: string }>()
)

export const scheduledDateFilterChanged = createAction(
	ServiceTaskActionTypes.ScheduledDateFilterChanged,
	props<{ dateFilter: string }>()
)

export const removeServiceTaskRequested = createAction(
	ServiceTaskActionTypes.RemoveServiceTaskRequested,
	props<{ taskId: string, recipientId: number }>()
)

export const removeServiceTaskCompleted = createAction(
	ServiceTaskActionTypes.RemoveServiceTaskCompleted
)